import { gql } from '@apollo/client'

import { RESTOCK_FRAGMENT } from './RestockFragment'
import { USER_FRAGMENT } from './UserFragment'

export const RESTOCK_GROUP_FRAGMENT = gql`
  fragment RestockGroup on RestockGroup {
    id
    created
    user {
      ...User
    }
    restocks {
      ...Restock
    }
    store {
      id
      location {
        name
      }
    }
    actionComplete {
      action {
        id
        title
        dueDateTime
        dueDate
        actionGenerator {
          id
        }
      }
    }
  }
  ${RESTOCK_FRAGMENT}
  ${USER_FRAGMENT}
`
